module.exports = __webpack_public_path__ + "static/img/2areaB_30.4454297.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/2areaB_30.png
// module id = 1142
// module chunks = 1